"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TabsContainer_1 = require("./TabsContainer");
exports.default = TabsContainer_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/TabsContainer/index.js
// module id = 1852
// module chunks = 8